/**
 * Navigate around submissions by updating store
 */
import { mapGetters, mapActions } from 'vuex';
import { SUBMISSION_VIEW_STEP_SUBMISSION, SUBMISSION_VIEW_STEP_PAGE, SUBMISSION_VIEW_GET_SUBMISSION } from '../core/store/action-types';


export default {
  name: 'submission-navigation',
  mixins: [
  ],
  created() {
  },
  mounted() {
  },
  computed: {
    ...mapGetters('submissionView', [
      'canNextPage',
      'canPreviousPage',
      'canNextSubmission',
      'canPreviousSubmission',
      'previousPageIndex',
      'nextPageIndex',
    ]),
  },
  methods: {
    ...mapActions({
      stepSubmission: SUBMISSION_VIEW_STEP_SUBMISSION,
      stepPage: SUBMISSION_VIEW_STEP_PAGE,
      getSubmission: SUBMISSION_VIEW_GET_SUBMISSION,
    })
  }
};
